import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _flatten from 'lodash/flatten';
import _isUndefined from 'lodash/isUndefined';
import _reduce from 'lodash/reduce';
import _isObjectLike from 'lodash/isObjectLike';
import _filter from 'lodash/filter';
import _keys from 'lodash/keys';
import _every from 'lodash/every';
import _intersection from 'lodash/intersection';
import _isString from 'lodash/isString';
import _get from 'lodash/get';
export function getFieldIds(unitItem) {
  // eslint-disable-line import/prefer-default-export
  if (typeof unitItem === 'string') {
    return [unitItem];
  }
  return _flatten((unitItem.rows || unitItem.columns).map(getFieldIds));
}
export function getFieldIdsFromUnits(units) {
  return _flatten(units.map(getFieldIds));
}
export function getFormErrors(fieldErrorPromises, prevErrors) {
  return Promise.all(Object.values(fieldErrorPromises)).then(function (errorMessages) {
    return _reduce(errorMessages, function (acc, data) {
      return _objectSpread(_objectSpread({}, acc), data);
    }, _objectSpread({}, prevErrors));
  });
}
export function isErrorEmpty(errors) {
  var _isErrorEmpty = function _isErrorEmpty(errs) {
    return _every(errs, function (value) {
      if (_isObjectLike(value)) return _isErrorEmpty(value);
      return !value;
    });
  };
  return _isErrorEmpty(errors);
}
export var filterRows = function filterRows(rows, entity, enabledChecksMap) {
  return rows.filter(function (row) {
    return !enabledChecksMap[row] || enabledChecksMap[row](entity);
  });
};
export var filterEnabledLayouts = function filterEnabledLayouts(layouts) {
  return layouts.filter(function (layout) {
    return (_isUndefined(layout.enabled) || layout.enabled) && layout.rows.length;
  });
};
export var getClassNameForFieldContainer = function getClassNameForFieldContainer(props) {
  if (props.error) return "error ".concat(props.fieldClassName);
  return props.fieldClassName;
};
var getSectionsList = function getSectionsList(sections) {
  return _reduce(sections, processSection, []);
};
var processSection = function processSection(accumulator, section) {
  return _reduce(_get(section, 'rows'), processRow, accumulator);
};
var processRow = function processRow(accumulator, row) {
  if (_isString(row)) {
    accumulator.push(row);
    return accumulator;
  }
  return _reduce(_get(row, 'columns'), processColumn, accumulator);
};
var processColumn = function processColumn(accumulator, column) {
  if (_isString(column)) {
    accumulator.push(column);
    return accumulator;
  }
  return _reduce(_get(column, 'rows'), processRow, accumulator);
};
export var isFormFilled = function isFormFilled(values, fields, errors, sections) {
  var requiredFields = _filter(_keys(fields), function (field) {
    return _get(fields[field], 'renderOptions.required');
  });
  var sectionList = getSectionsList(sections);
  var renderedRequiredList = _intersection(sectionList, requiredFields);
  var isComplete = _every(renderedRequiredList, function (field) {
    return values[field];
  });
  return isComplete && isErrorEmpty(errors);
};